import { render, staticRenderFns } from "./OpenTokLiveStream.vue?vue&type=template&id=3927ec55&scoped=true&"
import script from "./OpenTokLiveStream.vue?vue&type=script&lang=js&"
export * from "./OpenTokLiveStream.vue?vue&type=script&lang=js&"
import style0 from "./OpenTokLiveStream.vue?vue&type=style&index=0&id=3927ec55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3927ec55",
  null
  
)

export default component.exports